module.exports = __webpack_public_path__ + "img/blue-icon-en(1).30640093.png";